import { Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocalService } from '../../../../services/shared/local.service';

@Component({
  selector: 'app-duplicate-contacts-child',
  templateUrl: './duplicate-contacts-child.component.html',
  styleUrl: './duplicate-contacts-child.component.css'
})
export class DuplicateContactsChildComponent {
    @Input() subItems: any[] = [];
    @Input() columnChild: any[] = [];
    @Input() displayedColumns: string[] = [];
    @Input() user: any;
    @Input() dateFormat: string;

    dataSource = new MatTableDataSource<any>();

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(private localService: LocalService) {
    }

    ngAfterViewInit(): void {
        this.dataSource.data = this.subItems;
        this.dataSource.paginator = this.paginator;
    }
}
